import React, {useState, useCallback} from 'react';
import ethereum from 'decentralized/ethereum.js';
import CreateNewGuild from 'components/guilds/CreateNewGuild.js';

export default (props) => {
    const [guildName, setGuildName] = useState('');
    const [passphrase, setPassphrase] = useState('');

    const create = useCallback(async () => {
        await ethereum.guilds.newGuild(guildName, passphrase);
        props.done();
    }, [guildName, passphrase]);

    return (
        <div className="create-new-guild">
          <CreateNewGuild
            name={guildName}
            passphrase={passphrase}
            onNameChange={setGuildName}
            onPassphraseChange={setPassphrase}/>
          <div className="toolbar">
            <div
              onClick={create}
              className="done-button">
              Create 
            </div>
            <div
              onClick={props.cancel}
              className="cancel-button">
              Cancel
            </div>
          </div>
        </div>
    );
}
